module.exports = __webpack_public_path__ + "static/media/img-office-new.d1666f23.jpg";